/**
 * RunsFilterSelects — the Toolbar's scoped selects for the run history. Demo page: /tables/data-tables header selects.
 */
import React from 'react';
import { FilterSelect, type FilterOption } from '../../../components/ui/FilterSelect.js';

export const RUN_RANGES = [
  { value: '1h', label: 'Last hour', ms: 60 * 60 * 1000 },
  { value: '7d', label: 'Last 7 days', ms: 7 * 24 * 60 * 60 * 1000 },
  { value: '30d', label: 'Last 30 days', ms: 30 * 24 * 60 * 60 * 1000 },
] as const;
export type RunRange = '24h' | (typeof RUN_RANGES)[number]['value'];
export const DEFAULT_RANGE_MS = 24 * 60 * 60 * 1000;

interface RunsFilterSelectsProps {
  range: RunRange;
  workflowId: string;
  triggeredBy: string;
  workflowOptions: readonly FilterOption[];
  triggerOptions: readonly FilterOption[];
  onRangeChange: (v: RunRange) => void;
  onWorkflowChange: (v: string) => void;
  onTriggerChange: (v: string) => void;
}

export const RunsFilterSelects: React.FC<RunsFilterSelectsProps> = ({
  range,
  workflowId,
  triggeredBy,
  workflowOptions,
  triggerOptions,
  onRangeChange,
  onWorkflowChange,
  onTriggerChange,
}) => (
  <>
    <FilterSelect
      label="Time range"
      anyLabel="Last 24 hours"
      value={range === '24h' ? '' : range}
      options={RUN_RANGES}
      onChange={(v) => onRangeChange(v === '' ? '24h' : (v as RunRange))}
    />
    <FilterSelect
      label="Workflow"
      anyLabel="All workflows"
      value={workflowId}
      options={workflowOptions}
      onChange={onWorkflowChange}
    />
    <FilterSelect
      label="Trigger"
      anyLabel="Any trigger"
      value={triggeredBy}
      options={triggerOptions}
      onChange={onTriggerChange}
    />
  </>
);
